import React from 'react';

import ClusterPart from "./ClusterPart";

export default ({ component, hideDecommissioned, allSitesContext }) => {
  return (
    <ClusterPart
      part={component}
      hideDecommissioned={hideDecommissioned}
      allSitesContext={allSitesContext}
    />
  );
}